import { institution } from "../client";
const config = {
  headers: {},
  signal: null,
};

export const addInstitution = (params) => {
  const user = {
    flag: "addInstitution",
    parameters: {
      institution: params,
    },
  };
  return institution.post("/add/institution", user);
};

export const getInstitutions = (params) => {
  const user = {
    flag: "getInstitution",
    parameters: {
      institution: params,
    },
  };
  return institution.post("/get/institution", user);
};

export const updateInstitution = (params) => {
  const user = {
    flag: "updateInstitution",
    parameters: {
      institution: params,
    },
  };
  return institution.post("/update/institution", user);
};

export const deleteInstitution = (params) => {
  const user = {
    flag: "deleteInstitution",
    parameters: {
      institution: params,
    },
  };
  return institution.delete("/delete/institution", { data: user });
};
